import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import global from '../../../common/utility/global';


import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {

    return (
        <CustomTable
            style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}

            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[

                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoCliente',
                    key: 'tipoDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Nro Documento',
                    dataIndex: 'numeroDocumentoCliente',
                    key: 'numeroDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Cliente',
                    dataIndex: 'razonSocialCliente',
                    key: 'razonSocialCliente',
                    sorter: true
                },
                {
                    title: 'Moneda Original',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },
                {
                    title: 'Tipo Cambio',
                    dataIndex: 'tipoCambio',
                    key: 'tipoCambio',
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },
                {
                    title: 'Monto Total',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Soles',
                            dataIndex: 'totalSoles',
                            key: 'totalSoles',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                            render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            )
                        },
                        {
                            title: 'Dólares',
                            dataIndex: 'totalDolares',
                            key: 'totalDolares',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                            render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            )
                        }
                    ]
                },

                {
                    title: 'Cobrado',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Soles',
                            dataIndex: 'canceladoSoles',
                            key: 'canceladoSoles',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                            render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            )
                        },
                        {
                            title: 'Dólares',
                            dataIndex: 'canceladoDolares',
                            key: 'canceladoDolares',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                            render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            )
                        }
                    ]
                },

                {
                    title: 'Por Cobrar',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Soles',
                            dataIndex: 'saldoSoles',
                            key: 'saldoSoles',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                            render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            )
                        },
                        {
                            title: 'Dólares',
                            dataIndex: 'saldoDolares',
                            key: 'saldoDolares',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                            render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            )
                        }
                    ]
                }

            ]}
        />
    );
}